import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M14 20h6v-6a3 3 0 0 0 -6 0v6","key":"svg-1"}],["path",{"d":"M11 8v2.5a3.5 3.5 0 0 1 -3.5 3.5h-.5a3 3 0 0 1 0 -6h4","key":"svg-2"}]]

const IconBrandSpacehey = createReactComponent('outline', 'brand-spacehey', 'BrandSpacehey', __iconNode);

export default IconBrandSpacehey;